import clsx from 'clsx';

/**
 * Card wrapper for the mobile (below md) list view that replaces a <table>
 * row. Tables don't reflow well under ~400px, so every data table in the app
 * renders a `hidden md:block` <table> for desktop and a `md:hidden` stack of
 * these cards for mobile, built from the same row data.
 */
export function MobileCard({ children, className, ...props }) {
  return (
    <div className={clsx('rounded-xl border border-border bg-background-elevated p-4 space-y-2', className)} {...props}>
      {children}
    </div>
  );
}

/** Label/value line inside a MobileCard, mirroring a table cell pair. */
export function DataRow({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <span className="text-foreground-subtle shrink-0">{label}</span>
      <span className="text-foreground text-right truncate">{value}</span>
    </div>
  );
}

export default MobileCard;
